/**
 * NOTE: this handlers are for DEVELOPMENT process only
 * for TEST porpouses create the handlers in the test file
 * Or mock them in a "test utils" folder if needed to be reused
 */
import { http, HttpResponse, passthrough } from 'msw'
import autotaskMockApis from './autotaskMockApis'
import tableMockApis from './tableMockApis'

const ROOT = process.env.REACT_APP_AUGMENTT_API_URL

/**
 * This function is necessary due to the format of the API when in develop mode.
 * Which is http://localhost:3001/api?url=API_URL
 * If the request should be mocked it will update the destination and redirect
 * Otherwise it will ignore and request will be handled by the backend
 */
function redirectIfMock({ request }) {
  const isMock = request.headers.get('msw-mock-api')

  if (isMock) {
    const url = new URL(request.url)
    const { origin } = window.location
    const path = url.href.replace(ROOT, '').replace('&', '?')
    return HttpResponse(null, {
      status: 301,
      headers: { location: `${origin}${path}` },
    })
  }

  return passthrough()
}

const handlers = [
  http.get(ROOT, redirectIfMock),
  http.post(ROOT, redirectIfMock),
  http.put(ROOT, redirectIfMock),
  http.patch(ROOT, redirectIfMock),
  http.delete(ROOT, redirectIfMock),
  http.options(ROOT, redirectIfMock),
  ...tableMockApis,
  ...autotaskMockApis,
]

export default handlers
